export default {
  title: {
    en: 'Before you go...',
  },
  text: {
    en: 'We are so sorry to see you go...',
  },
  changeFrequencyText: {
    en: 'Getting too many perfumes?',
  },
  skipAMonthText: {
    en: 'Need a break?',
  },
}
